import {
    SET_RESRVATION_DATES,
    SET_SELECTED_RESERVATION_DATE,
    SET_CART_DATA,
    SET_RESERVE_LOADING,
    SET_DATES_LOADING,
    SHOW_CONFLICT_MSG,
    SET_DAY_CONF
} from '../actions/actionTypes'
import { reservationDates, holdReservation, releaseReservation,pclClientId } from '../api/apiConstants';
import { postData } from "../utils/spaUtils";
import { selectGuest, selectService } from './spaServices.actions'
import { apiRequestsConstants } from '../utils/spaConstants';
import * as reservationActionHelper from '../actions/helpers/reservationActionHelper';
//import _ from 'lodash';
import remove from 'lodash/remove';

export const selectReserveDate = (date, flag) => {
    return  (dispatch, getState) => {
        //Checking exact match for undefined
        if (flag === undefined) {
            var { reservations, services } = getState();
            let { selectedReserveDate = false } = reservations;
            dispatch(setDayConflicts(''));
            if (selectedReserveDate && selectedReserveDate[0] && selectedReserveDate[0].serviceDate === date[0].serviceDate) {
                dispatch(setSelectedReserveDate(''));
                return;
            }

        }

        let dayConflicts = reservationActionHelper.getDayConflicts(date, services, reservations);

        if (dayConflicts)
            dispatch(setDayConflicts(dayConflicts));
        // dispatch(setSelectedReserveDate(''));
        setTimeout(function () {
            dispatch(setSelectedReserveDate(date));
        }, 0);
    }
}

const setDayConflicts = (dayConflicts) => {
    return {
        type: SET_DAY_CONF,
        dayConflictsMsg: dayConflicts
    }
}

export const setSelectedReserveDate = (date) => {
    return {
        type: SET_SELECTED_RESERVATION_DATE,
        selectedReserveDate: date
    }
}



export const getReservationDates = () => {
    return async (dispatch, getState) => {
        let { services, reservations } = getState();
        let { cart = [] } = reservations;
        let _reqBody = {};
        let reqHeader = {}
        reqHeader.AuthToken = services.authDetails.AuthToken
        reqHeader.AppId = 'SPA' + services.authDetails.AuthToken
        reqHeader.ProductCompany = 'PC';
        reqHeader.BookingCompany = 'PC';
        reqHeader['pcl-client-id'] = pclClientId
        let queryUrl = `${reservationDates}?startDate=${services.cruiseStartDate}&&endDate=${services.cruiseEndDate}&&service=${services.selectedService.treatmentId}&&vesselId=${services.bookingDetails.vesselId}&&serviceTime=''`;
        dispatch(setReservationDatesLoading(true));
        try {
            const response = await postData(queryUrl, _reqBody, reqHeader);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            let payload = response.json();
            payload.then((items) => {
                    reservationActionHelper.processResrveDates(items, cart, dispatch)
                    dispatch(setReservationDatesLoading(false));
                //else
                //showConflictMsg('Unable to Retrieve Available Dates. Please Try Again')
            })
            //.catch(() => dispatch(showConflictMsg('Unable to Retrieve Available Dates. Please Try Again')));
        } catch (e) {
            //dispatch(showConflictMsg('Unable to Retrieve Available Dates. Please Try Again'));
        }

    };
}

export const setReservationDatesLoading = (isDatesLoading) => {
    return {
        type: SET_DATES_LOADING,
        isDatesLoading
    }
}

export const setReservationDates = (reservationDates) => {
    return {
        type: SET_RESRVATION_DATES,
        reservationDates
    }
}


export const addServiceToCart = (service, inCartClass) => {
    return  (dispatch, getState) => {
        dispatch(showConflictMsg(''));
        if (inCartClass) {
            //Release From Steiner
            dispatch(holdReleaseReserveService(service, 'release'));
        } else {
            //Hold service in Steiner
            let isConflict = reservationActionHelper.checkConflicts(getState(), service);
            if (isConflict) {
                dispatch(showConflictMsg(isConflict));
                return;
            }
            dispatch(holdReleaseReserveService(service, 'hold'));
        }
    }
}

export const showConflictMsg = (msg) => {
    return {
        type: SHOW_CONFLICT_MSG,
        msg
    }
}

export const holdReleaseReserveService = (service, action) => {
    return async (dispatch, getState) => {
        let _reqBody = apiRequestsConstants['holdReservation'];
        dispatch(showConflictMsg(''));
        let { services, reservations } = getState();
        let { selectedGuestDetails } = services;
        //_reqBody.VesselID = services.bookingDetails.Product.Cruise.Voyage.Ship.Id;
        //_reqBody.Service = service.treatmentId;
        //_reqBody.ResHoldId = "" + service.resHoldId;
        // _reqBody.VesselID = services.bookingDetails.vesselId;
        _reqBody.passengerId = services.bookingDetails.BookingNumber + selectedGuestDetails.PaxId;
        _reqBody.paxFirstName = selectedGuestDetails.PassengerDetail.Name.FirstName;
        _reqBody.paxLastName = selectedGuestDetails.PassengerDetail.Name.LastName;
        _reqBody.paxCabin = '';


        let reqHeader = {};
        reqHeader.AuthToken = services.authDetails.AuthToken;
        reqHeader.AppId = 'SPA' + services.authDetails.AuthToken;
        reqHeader.ProductCompany = 'PC';
        reqHeader.BookingCompany = 'PC';
        reqHeader['pcl-client-id'] = pclClientId

        let _holdReservation = `${holdReservation}?service=${service.treatmentId}&&vesselId=${services.bookingDetails.vesselId}&&resHoldId=${service.resHoldId}`;
        let _releaseReservation = `${releaseReservation}?vesselId=${services.bookingDetails.vesselId}&&resHoldId=${service.resHoldId}`

        let url = action === 'release' ? _releaseReservation : _holdReservation;
        let reqBody = action === 'release' ? {} : _reqBody;

        dispatch(isReserveLoading(true, service));
        const response = await postData(url, reqBody, reqHeader);
        let payload = response.json();

        if (!response.ok) {
            throw Error(response.statusText);
        }

        payload.then((result) => {
            let { cart } = reservations;
            if (action === 'release') {
                //if (result.releaseReservationResult.result === 0 || result.releaseReservationResult.result === 1) {
                    remove(cart, (item) => item.resHoldId === service.resHoldId)
                    dispatch(getReservationDates());
               // }
            } else {
                    cart.push({ ...service, ...selectedGuestDetails });
            }
            dispatch(setCartData(cart));
            //dispatch(isReserveLoading(false));
        })
        dispatch(isReserveLoading(true));
    }
}


export const cancelCartItem = (service) => {
    return async (dispatch, getState) => {
        let { services, reservations } = getState();
        let reqHeader = {};
        reqHeader.AuthToken = services.authDetails.AuthToken;
        reqHeader.AppId = 'SPA' + services.authDetails.AuthToken;
        reqHeader.ProductCompany = 'PC';
        reqHeader.BookingCompany = 'PC';
        reqHeader['pcl-client-id'] = pclClientId
        let _releaseReservation = `${releaseReservation}?vesselId=${services.bookingDetails.vesselId}&&resHoldId=${service.resHoldId}`
        let reqBody = {};
        const response = await postData(_releaseReservation, reqBody, reqHeader);
        let payload = response.json();
        if (!response.ok) {
            throw Error(response.statusText);
        }
        payload.then((result) => {
            let { cart } = reservations;
           // if (result.releaseReservationResult.result === 0 || result.releaseReservationResult.result === 1) {
            remove(cart, (item) => item.resHoldId === service.resHoldId)
            //}
            dispatch(setCartData(cart));
        });
    }
}

export const isReserveLoading = (isloading, service) => {
    return {
        type: SET_RESERVE_LOADING,
        isReserveLoading: isloading,
        selectedReservation: service
    }
}


export const setCartData = (cart) => {
    return {
        type: SET_CART_DATA,
        cart
    }
}

export const extendCartItems = () => {
    return (dispatch, getState) => {
        let { reservations } = getState();
        let { cart = [] } = reservations;
        if (cart && cart.length > 0) {
            //    let parallelExtends =  Promise.all(reservationActionHelper.cartExtendAllPosts(cart,holdReservation,getState()));
            //    parallelExtends.then((responses)=>{
            //        if(responses[0].ok)
            //          dispatch(initiateCartExtendTimer());
            //    });
        }
    }
}

export const clearReservationDates = () => {
    return (dispatch, getState) => {
        dispatch(isReserveLoading(false, {}));
        dispatch(showConflictMsg(''));
        dispatch(selectService({}));
        dispatch(setReservationDates(false));
        dispatch(setSelectedReserveDate(false));
        dispatch(selectGuest(false));
    }
}


